import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { BaseCrud, Operator } from 'core-components/types'

import { GroupFilterSelector } from './groupFilter/GroupFilterSelector'
import {
  extractFieldValueFromFilter,
  getFilterWithoutFieldFilter,
} from './groupFilter/helpers/filter'

interface IGroupFilter {
  source: BaseCrud
  onBlur: () => void
  field: string
  currentOperation: Operator
}

export const GroupFilter = ({ source, onBlur, field }: IGroupFilter) => {
  const [currentFilterValue, setCurrentFilterValue] = useState(() => {
    const fieldValue = extractFieldValueFromFilter(source, field)
    return fieldValue === null ? '' : fieldValue.toString()
  })

  const apply = () => {
    if (currentFilterValue) {
      const newFilter = getFilterWithoutFieldFilter(source, field)

      newFilter.filters.push({
        field: 'group',
        value: currentFilterValue,
        operator: Operator.EQUAL,
      })

      source.setFilter(newFilter)
    }
    onBlur()
  }

  const clear = () => {
    source.setFilter(getFilterWithoutFieldFilter(source, field))
    onBlur()
  }

  return (
    <Flex flexDirection={'column'}>
      <GroupFilterSelector value={currentFilterValue} onChange={setCurrentFilterValue} />
      <Flex justifyContent={'space-between'}>
        <Button onClick={apply} disabled={!currentFilterValue}>
          Apply
        </Button>
        <Button color={'danger'} variant={'text'} onClick={clear}>
          Clear
        </Button>
      </Flex>
    </Flex>
  )
}
